var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWtagBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 19,
    viewBox: "0 0 91 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 618",
    d: "M1 5.93207L7.26662 1H83.5106L89.7772 5.93207V12.2092L83.5106 17.5897H7.26662L1 12.2092V5.93207Z",
    stroke: "black",
    strokeWidth: 1.34511
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtagBackground);
export default __webpack_public_path__ + "static/media/wtag-background.2d0268c03d79d03f0473770c66289023.svg";
export { ForwardRef as ReactComponent };